var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHpShoesNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.49,864H72a8,8,0,0,0-8,8v80a8,8,0,0,0,8,8H403.54A8,8,0,0,0,409,946.12l-79.78-73.63a32,32,0,0,0-21.7-8.49Z",
    style: {
      fill: "#777"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.69,130.93A224.23,224.23,0,0,0,640,317.75v.87c-1,22.65-.94,45.59.06,68.2a795.65,795.65,0,0,0,18.63,139.24l2.15,9.53,4.89,8.45A192.66,192.66,0,0,0,832,640a64.07,64.07,0,0,1,64,64V896H603.65L152.72,416.88l51.77-53.21L248,318.92,406.67,155.84a95.46,95.46,0,0,1,30.87-20.53,97.48,97.48,0,0,1,13.15-4.38M480,64h-5.73a160,160,0,0,0-113.13,46.86l-159,163.43L158.62,319,75,405a16,16,0,0,0-.34,22.28L566.52,949.93A32,32,0,0,0,589.83,960H944a16,16,0,0,0,16-16V704A128,128,0,0,0,832,576a127.93,127.93,0,0,1-110.87-64A729.42,729.42,0,0,1,704,384c-1-22.6-.88-44,0-64V288a32,32,0,0,0-32-32A160,160,0,0,1,512,96a32,32,0,0,0-32-32Z",
    style: {
      fill: "#777"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520,448H704a0,0,0,0,1,0,0v64a0,0,0,0,1,0,0H520a8,8,0,0,1-8-8V456A8,8,0,0,1,520,448Z",
    style: {
      fill: "#777"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520,320H704a0,0,0,0,1,0,0v64a0,0,0,0,1,0,0H520a8,8,0,0,1-8-8V328A8,8,0,0,1,520,320Z",
    style: {
      fill: "#777"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.06 319.92 204.49 363.67 202.46 365.76 640 832 895.96 832 896 760 680 760 247.06 319.92 247.06 319.92",
    style: {
      fill: "#777"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpShoesNormal);
export default __webpack_public_path__ + "static/media/hp_shoes_normal.0ba27eea34b327c09cad453b9a1bcf39.svg";
export { ForwardRef as ReactComponent };